import { render } from "./ProductsCarImages.vue?vue&type=template&id=40edfff6"
import script from "./ProductsCarImages.vue?vue&type=script&lang=js"
export * from "./ProductsCarImages.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./ProductsCarImages.vue?vue&type=style&index=0&id=40edfff6&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script